<template>
    <div id="app">
        <div id="top">
            <div class="btnback" @click="handleClickBack"><p>BACK</p></div>
        </div>
        <iframe
            :v-if="loaded"
            :src="iframe.src"
            :style="iframe.style"
            :height="iframe.style != null ? iframe.style.height : 0"
            :width="iframe.style != null ? iframe.style.width : 0"
            frameborder="0">
        </iframe>
    </div>
</template>
<script>
    export default {
        name: 'framewithback',
        props: ['page'],
        data(){
            var url
            switch (this.page) {
                case 'tos':
                case 'policy':
                    url = 'https://www.enuma.com/' + this.page
                    break;

                default:
                    break;
            }
            return {
                loaded: false,
                iframe: {
                    src: url,
                    style: null,
                },
                menuHeight: 60
            }
        }, 
        mounted() {
            this.resizeHandler()    
            this.loaded = true
            window.addEventListener('resize', this.resizeHandler)
        },
        destroyed() {
            window.removeEventListener('resize', this.resizeHandler)
        },
        methods: {
            resizeHandler() {
                this.iframe.style = {
                    position: 'absolute',
                    width: window.innerWidth,
                    height: window.innerHeight - this.menuHeight,
                    top: this.menuHeight + "px"
                }    
            },
            handleClickBack() {
                this.$router.go(-1)
            }
        }
    }
</script>
<style scoped>
#top {
    border-bottom: 1px solid #f2f0e9;
    height: 59px;
    text-align: center;
}
.btnback {
    width: 164px;
    height: 48px;
    object-fit: contain;
    border-radius: 24px;
    background-color: #f2f0e9;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    margin-top: 5px;
}
.btnback p {
    margin-top: 15px;
}
</style>